import { useSyncExternalStore } from 'react'

const SPLITS_CONNECT_RDNS = 'org.splits.teams.connect'

let isInstalled = false // sticky for the page lifetime
const notifiers = new Set<() => void>()

const hasInjectedProvider = () =>
  typeof window !== 'undefined' &&
  !!(window as { splitsEthereum?: unknown }).splitsEthereum

const markInstalled = () => {
  isInstalled = true
  notifiers.forEach((notify) => notify())
}

// Permanent listener + one request, set up on import: an early injection answers
// the request, a late one trips the still-attached listener. No polling needed.
if (typeof window !== 'undefined') {
  window.addEventListener('eip6963:announceProvider', (event) => {
    // detail can be null from misbehaving extensions
    const detail = (event as CustomEvent).detail
    if (detail?.info?.rdns === SPLITS_CONNECT_RDNS) {
      markInstalled()
    }
  })
  window.dispatchEvent(new Event('eip6963:requestProvider'))
}

const subscribe = (onStoreChange: () => void) => {
  notifiers.add(onStoreChange)
  return () => {
    notifiers.delete(onStoreChange)
  }
}

/** Whether the Splits Connect extension is active in this browser. */
export const useIsSplitsConnectInstalled = () =>
  useSyncExternalStore(
    subscribe,
    () => isInstalled || hasInjectedProvider(),
    () => false,
  )
